import { isOutsidePerformanceLens } from "../v2/lib/performance-lens/designation-scope.ts";

const labels = {
  HOD: "Head of Delivery",
  DL: "Delivery Lead",
  PM: "Project Manager",
  SA: "Solution Architect",
  BA: "Business Analyst",
  DEV: "Developer",
  QA: "Quality Analyst",
  CONSULTANT: "Consultant",
};

export const performanceLensRoleOptions = (designation) =>
  isOutsidePerformanceLens(designation?.value ?? designation?.designationCode)
    ? []
    : (designation?.performanceRoles || []).map((value) => ({ value, label: labels[value] || value }));

export const performanceLensRoleSelectOptions = (designation) =>
  performanceLensRoleOptions(designation).map(({ value, label }) => ({ value, label }));
